export class AppConfig {

    public static get path(): string {
        const hostname = window.location.hostname;

        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            // Ambiente de desenvolvimento
            return 'http://localhost:3333/';
        } else if (hostname === 'dev.adm.fastparking.com.br') {
            return 'https://dev.api.fastparking.com.br/';
        }
        else {
            // Ambiente de produção
            return 'https://api.fastparking.com.br/';
            // return 'https://dev.api.fastparking.com.br';
            //return "http://64.225.27.31:3333/";
            // return "https://api.fastparking.com.br/";
            // return "https://174.129.166.78/"
        }
    }

}
